import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Paper, Typography } from '@material-ui/core'

import LoginPanel from '../common/LoginPanel'
import FiriaLabsBanner from '../common/firialabsbanner.png'

import DashboardIcon from '../assets/dashimg.png'
import { useLocation, useNavigate } from 'react-router-dom'

const rightDrawerWidth = '23em'
const appHeaderHeight = '4em'

const useStyles = makeStyles(theme => ({
  appHeader: {
    backgroundColor: 'white',
    position: 'relative',
    zIndex: theme.zIndex.appBar,
    display: 'flex',
    alignItems: 'center',
  },
  // Three columns: the two sides flex to equal width, so whatever the center
  // holds is truly centered on the bar no matter how wide the nav tabs or the
  // login panel grow. The previous absolute-centered banner overlapped the
  // tabs; flex columns compress instead of stacking on top of each other.
  headerSide: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    height: appHeaderHeight,
    // min-width: 0 lets the column shrink past its content, which is what
    // keeps the banner centered on a narrow window. Clip rather than let the
    // overflow spill across the middle of the bar.
    overflow: 'hidden',
  },
  headerSideLeft: {
    paddingLeft: 15,
  },
  headerSideRight: {
    paddingRight: 15,
    justifyContent: 'flex-end',
  },
  // The tabs are centered in whatever space is left between the dashboard
  // mark and the banner: the slot takes the remainder of the left column and
  // centers the nav inside it, and its own padding is the only fixed offset
  // on either side — so the two gaps stay equal at every width. Nothing else
  // may sit between the slot and the banner, which is why the columns carry
  // their padding on the outer edges only.
  navSlot: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    justifyContent: 'center',
    padding: '0 16px',
  },
  headerItemCenter: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    flexShrink: 0,
  },
  headerImage: {
    height: '3em',
  },
  headerImage2: {
    alignSelf: 'center',
    height:appHeaderHeight,
    margin: 'auto',
  },
  headerText: {
    color: 'black',
    fontSize: '0.9em',
    whiteSpace: 'nowrap',
  },
  navTabs: {
    display: 'flex',
    alignSelf: 'center',
    border: '1px solid rgba(0, 0, 0, 0.28)',
    borderRadius: 6,
    overflow: 'hidden',
  },
  navTab: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.8rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    whiteSpace: 'nowrap',
    padding: '8px 18px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: '#f2f2f2',
    color: 'rgba(0, 0, 0, 0.55)',
    transition: 'background-color 0.12s, color 0.12s, box-shadow 0.12s',
    '& + &': {
      borderLeft: '1px solid rgba(0, 0, 0, 0.22)',
    },
    '&:hover': {
      backgroundColor: '#e9e9e9',
    },
    // The depressed half of the switch: filled, inverted, inset like a pressed key.
    '&[aria-pressed="true"]': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
      boxShadow: 'inset 0 2px 5px rgba(0, 0, 0, 0.3)',
    },
  },
}))

function ClassDashboardSiteHeader() {
  const classes = useStyles()
  const navigate = useNavigate()
  const location = useLocation()
  // Educator Resources is a sibling section of My Classes, not a drill-down;
  // tabs keep both destinations visible (the yellow button was a one-way door).
  const onResources = location.pathname.startsWith('/educator-resources')
  // The shadow separates the header from the flat white resources page. My
  // Classes renders its own sub-header directly beneath, where a drop shadow
  // reads as a seam, so the header sits flush there.
  const headerElevation = onResources ? 5 : 0

  return (
    <Paper square elevation={headerElevation} className={classes.appHeader}>
      <div className={`${classes.headerSide} ${classes.headerSideLeft}`}>
        <div className={classes.brand}>
          <img className={classes.headerImage} alt={''} src={DashboardIcon}/>
          <Typography variant='h6' className={classes.headerText}>
            {'Dashboard'}
          </Typography>
        </div>
        <div className={classes.navSlot}>
          <nav className={classes.navTabs} aria-label='Dashboard sections'>
            <button
              type='button'
              className={classes.navTab}
              aria-pressed={!onResources}
              onClick={() => navigate('/')}
            >
              {'My Classes'}
            </button>
            <button
              type='button'
              className={classes.navTab}
              aria-pressed={onResources}
              onClick={() => navigate('/educator-resources')}
            >
              {'Educator Resources'}
            </button>
          </nav>
        </div>
      </div>

      <div className={classes.headerItemCenter}>
        <img className={classes.headerImage2} alt={''} src={FiriaLabsBanner}/>
      </div>

      <div className={`${classes.headerSide} ${classes.headerSideRight}`}>
        <LoginPanel />
      </div>
    </Paper>
  )
}

export { ClassDashboardSiteHeader, rightDrawerWidth, appHeaderHeight }
